// extracted by mini-css-extract-plugin
export default {"usericon":"Navigation_usericon__afJpM","btn":"Navigation_btn__OUXNv"};